import {
  FBI_EDIT_CHANGE_VERSION,
  FBI_EDIT_START,
  FBI_EDIT_NODE_END,
  FBI_SET_CREATE_EVENT_BLOCK_FORM_ID,
  FBI_EDIT_REMOVED_DISMISSIBLE_WARNING,
} from 'actions/flowBlockInput';

export const INITIAL_STATE = {
  scriptStep: null,
  editScriptStepInput: false,
};

export const FIRST_STATE = {
  ...INITIAL_STATE,
  hasShownDismissibleWarning: false,
};

export default function flowBlockScriptStep(state = FIRST_STATE, action) {
  switch (action.type) {
    case FBI_EDIT_START: {
      return {
        ...state,
        scriptStep: {
          ...state.scriptStep,
          ...action.payload,
        },
        editScriptStepInput: true,
      };
    }
    case FBI_SET_CREATE_EVENT_BLOCK_FORM_ID: {
      return {
        ...state,
        scriptStep: {
          ...state.scriptStep,
          uuid: action.payload.formId,
        },
      };
    }
    case FBI_EDIT_NODE_END:
      return { ...state, ...INITIAL_STATE };

    case FBI_EDIT_CHANGE_VERSION: {
      return {
        ...state,
        scriptStep: {
          ...state.scriptStep,
          uuid: action.version.uuid,
        },
      };
    }

    case FBI_EDIT_REMOVED_DISMISSIBLE_WARNING:
      return {
        ...state,
        hasShownDismissibleWarning: true,
      };

    default:
      return state;
  }
}
